<article>
  <div class="flex flex-row justify-end">
    <button mat-icon-button data-testid="closeLineup" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="flex flex-col xl:flex-row">
    <div class="w-full xl:w-1/2">
      <div class="flex flex-row flex-wrap">
        <h2>{{game.game.homeTeam.teamName}}</h2>
        <button mat-icon-button data-testid="addPlayerHome" (click)="addPlayerPopUp(game.game.homeTeam.id)" title="{{ 'components.dialogLineUp.addPlayer' | transloco }}">
          <mat-icon>add</mat-icon>
        </button>
        <mat-checkbox data-testid="selectAllHomePlayer" class="select-all-cb-position" [checked]="anyHomeActiveStatuses" (change)="selectAllPlayers(homeLineup, $event.checked)" title="{{ 'components.dialogLineUp.selectAll' | transloco }}">
        </mat-checkbox>
      </div>

      <div class="flex flex-row flex-wrap">
        @for (player of homeLineup.fullTeam; track player; let i = $index) {
          <section class="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/2 player-card">
            <mat-checkbox [(ngModel)]="homeActiveStatuses[i]" (change)="onPlayerLineUpChange($event, player, homeLineup, i)">
              <span>{{ player.gamesPlayed[0]?.gameJerseyNumber || player.jerseyNumber }} - {{ player.fullName }} </span>
              <span>
                ({{ getPlayerPositions(player) }})
              </span>
            </mat-checkbox>
            <button mat-icon-button data-testid="editPlayerHome" (click)="editPlayerPopUp(player)" title="{{ 'components.dialogLineUp.editPlayer' | transloco }}">
              <mat-icon>edit</mat-icon>
            </button>
          </section>
        }
      </div>
    </div>

    <div class="w-full xl:w-1/2">
      <div class="flex flex-row flex-wrap">
        <h2>{{game.game.awayTeam.teamName}}</h2>
        <button mat-icon-button data-testid="addPlayerAway" (click)="addPlayerPopUp(game.game.awayTeam.id)" title="{{ 'components.dialogLineUp.addPlayer' | transloco }}">
          <mat-icon>add</mat-icon>
        </button>
        <mat-checkbox mat-icon-button data-testid="selectAllAwayPlayer" class="select-all-cb-position" [checked]="anyAwayActiveStatuses" (change)="selectAllPlayers(awayLineup, $event.checked)" title="{{ 'components.dialogLineUp.selectAll' | transloco }}">
        </mat-checkbox>
      </div>

      <div class="flex flex-row flex-wrap">
        @for (player of awayLineup.fullTeam; track player; let i = $index) {
          <section class="w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/2 player-card">
            <mat-checkbox [(ngModel)]="awayActiveStatuses[i]" (change)="onPlayerLineUpChange($event, player, awayLineup, i)"></mat-checkbox>
            <span>{{ player.gamesPlayed[0]?.gameJerseyNumber || player.jerseyNumber }} - {{ player.fullName }} </span>
            <span>
              ({{ getPlayerPositions(player) }})
            </span>
            <button mat-icon-button data-testid="editPlayerAway" (click)="editPlayerPopUp(player)" title="{{ 'components.dialogLineUp.editPlayer' | transloco }}">
              <mat-icon>edit</mat-icon>
            </button>
          </section>
        }
      </div>
    </div>
  </div>
</article>
